module.exports = __webpack_public_path__ + "img/favicon-64x64.f98c9c4c.png";